
import React from 'react';
import TreatmentPageTemplate from './TreatmentPageTemplate';

const LipFiller = () => {
  const treatmentData = {
    title: "Lip Filler",
    subtitle: "Natural lip enhancement for fuller, more defined lips",
    description: "Our expert injectors use premium hyaluronic acid fillers to create beautiful, natural-looking lip enhancement. Whether you want subtle volume or dramatic definition, we'll help you achieve your perfect pout.",
    whoItsFor: [
      "Anyone wanting fuller, more defined lips",
      "Those with asymmetrical lips",
      "People seeking to restore lost lip volume",
      "Clients wanting a more youthful appearance",
      "Anyone looking to enhance their natural lip shape"
    ],
    packages: [
      {
        name: "Lip Enhancement",
        visitorPrice: "$650",
        memberPrice: "$585",
        description: "Single syringe of premium hyaluronic acid filler"
      },
      {
        name: "Full Lip Transformation",
        visitorPrice: "$1,200",
        memberPrice: "$1,080",
        description: "Two syringes for dramatic enhancement and perfect symmetry"
      },
      {
        name: "Lip Refresh",
        visitorPrice: "$400",
        memberPrice: "$360",
        description: "Touch-up treatment for existing filler clients"
      }
    ],
    beforeCare: [
      "Avoid blood thinners for 1 week",
      "Stay hydrated",
      "Avoid alcohol 24 hours prior",
      "No dental work 2 weeks before/after"
    ],
    duringCare: [
      "Precise injection technique",
      "Immediate shaping and massage",
      "20-30 minute treatment time",
      "Minimal discomfort with topical numbing"
    ],
    afterCare: [
      "Apply ice for 10-15 minutes",
      "Avoid strenuous exercise for 24 hours",
      "No kissing or pressure for 2 hours",
      "Results visible immediately, settle in 2 weeks"
    ],
    memberPerks: [
      "10% discount on all lip filler treatments",
      "Priority booking for touch-up appointments",
      "Complimentary lip care consultation",
      "Access to exclusive after-care products",
      "Free touch-up within 2 weeks if needed"
    ]
  };

  return <TreatmentPageTemplate {...treatmentData} />;
};

export default LipFiller;
